import { enhancedApi } from '@store/generated/npi';

export type {
  NpiExpectedType,
  NpiValidationStatus,
  ValidateNpiResponse,
} from '@store/generated/npi';

/**
 * NPI validation API — extends the generated OpenAPI client so we use the
 * generated types/endpoints. The validate call is a pure read (no cache tags).
 */
export const npiApi = enhancedApi.enhanceEndpoints({});

// Export hook with a user-friendly name.
export const { usePostV2ProviderNpiValidateMutation: useValidateNpiMutation } = npiApi;
